import { VueExtension } from "../../utils/extensions/vue";
import SliderScale from './sliderscale.jsx'
import './sliderscale.scss'

VueExtension.WithInstall(SliderScale)

export default SliderScale